import * as React from 'react';
import { CloseIcon12 } from '../icons';
import * as styles from './Tag.css';

interface ITagProps {
  onDelete(): void;
}

export const Tag: React.FC<React.PropsWithChildren<ITagProps>> = ({ children, onDelete }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>{children}</div>
      <button type="button" className={styles['button']} onClick={onDelete}>
        <CloseIcon12 />
      </button>
    </div>
  );
};
